import React, { useEffect, useState } from 'react';
import servicesApi from '../../seller-apis/servicesApi';
import api from '../../seller-apis/api';
import BrandTable from './BrandTable';
import { useHistory } from 'react-router-dom';
import PaginationCom from '../common/Pagination';
import Button from '../Brands/Button';
var globalFilter = {
    "pageNo": 1,
    "size": 12
}
var outerdiv;
var loaderDiv;
const HEADERS = [
    {
        key: 'registeredOn',
        label: 'Registered On'
    },
    {
        key: 'brandName',
        label: 'Brand Name'
    },
    // {
    //     key: 'products',
    //     label: 'Products'
    // },
    {
        key: 'status',
        label: 'Status'
    },
    {
        key: 'subscription-status',
        label: 'Subscription Status'
    },
    {
        key: 'brandStore',
        label: 'Brand Store'
    },
]
function MyBrands(props) {
    const history = useHistory();
    const [rows, setRows] = useState([]);

    // sl-748
    const [ennewloader, setennewloader] = useState("flex");
    // Pagination related
    const [allRecords, setallRecords] = useState(1);
    const [selectedPage, setSelectedPage] = useState(1);

    // sl-748
    async function paginate(data) {
        let outerdiv = document.getElementById("orDeskContain");
        let loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
        setSelectedPage(data.number)
        globalFilter.pageNo = data.number
        setennewloader("flex");
        await fetchMyBrands()
        loaderDiv.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
        setennewloader("none")
    }

    useEffect(() => {
        if (localStorage.getItem("vendorState") === "partialInactive") {
            history.replace("/home");
            return false;
        }
        globalFilter = {
            "pageNo": 1,
            "size": 12
        }
        fetchMyBrands()
    }, [])

    const fetchMyBrands = async () => {
        try {
            const res = await api.TradeMark.sellerTradeMark(globalFilter);
            setRows(res?.data?.data)
            setallRecords(res?.data?.totalRecords)
            if(res?.data?.totalRecords === 0){
                history.push('/apply-brand')
            }
            setennewloader("none")
        } catch (err) {
            console.log(err)
            setennewloader("none")
        }
    }

    const handleClick = () => {
        history.push('/apply-brand/1')
    }

    return (
        <div className='container py-2' id="orDeskContain">
            <div className='d-flex mb-3 mt-1' style={{justifyContent:"right"}}>
                <Button
                    value="Add a New Brand"
                    handleClick={handleClick}
                    icon={<img src="/brand/whiteplus.png" className='ms-2 my-auto' alt="Add A New Brand" height={18} />} />
            </div>
            <BrandTable
                headers={HEADERS}
                rows={rows}
            />
            {/* sl-748 */}
            <div class="d-flex justify-content-center" id="enNewLoader" >
                <div class="spinner-border" role="status" style={{ "display": ennewloader }}>
                    <span class="sr-only"></span>
                </div>
            </div>
            <PaginationCom
                number={allRecords}
                activ={selectedPage}
                paginate={paginate}
                comp="brand"
            />

        </div>
    )
}
export default MyBrands;